import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { setupAxiosInterceptors } from "../services/axiosConfig";

const UserContext = createContext();
export const useUser = () => useContext(UserContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [canAccessPortal, setCanAccessPortal] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  axios.defaults.withCredentials = true;
  // Fetch current user on initial load
  const publicRoutes = [
    "/login",
    "/signup",
    "/remind-password",
    "/reset-password",
  ];

  const isPublicPage = publicRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  useEffect(() => {
    const fetchUser = async () => {
      if (isPublicPage) {
        setLoading(false);
        return; // ✅ skip session check on public pages
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/admin/me`,
          {
            withCredentials: true,
          }
        );
        setUser(res.data);
        if (res.data.role === "MANAGER") {
          setCanAccessPortal(true);
        } else if (res.data.role === "CMT") {
          setCanAccessPortal(res.data.permission.canAccessPortal);
        }
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    setupAxiosInterceptors(logout);
    fetchUser();
  }, [location.pathname]);
  const login = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/me`,
        {
          withCredentials: true,
        }
      );
      setUser(res.data);
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/logout`,
        { withCredentials: true }
      );
    } catch {}
    setUser(null);
    setLoading(false);
    navigate("/login");
  };

  return (
    <UserContext.Provider value={{ user, setUser, loading, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};
